import { forwardRef } from 'react';
// icons
import { Icon, type IconifyIcon } from '@iconify/react';
// @mui
import { Box, type BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

interface IconifyProps extends BoxProps {
	icon: IconifyIcon | string;
	width?: number | string;
}

const Iconify = forwardRef<HTMLDivElement, IconifyProps>(({ icon, width = 20, sx, ...other }, ref) => (
	<Box ref={ref} component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
));

export default Iconify;
